import { useEffect } from 'react';
import { useParams } from 'react-router';
import PersonaVendeForm from '../../components/personal-vende/PersonaVendeForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalVendeStore,
  type ActualizarPersonaVende
} from '../../stores/personal-vende/personal-vende.store';

const EditarPersonaVende = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: persona,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = usePersonalVendeStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
    cargarCiudades();
    cargarEstados();
  }, [id]);

  const handleSave = (values: ActualizarPersonaVende) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <PersonaVendeForm
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default EditarPersonaVende;
